var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { cn } from "../../../helpers";
import { styles } from "./styles";
export function gridColumnMovingPlugin(config) {
    return function (_a) {
        var rootRef = _a.rootRef, bodyRef = _a.bodyRef, getColumns = _a.getColumns;
        var rootLeftOffset = 0;
        var scrollLeftOffset = 0;
        var currentColumnIndex = 0;
        function calculateColumnsOrder(_a) {
            var prevIndex = _a.prevIndex, nextIndex = _a.nextIndex;
            var isForwardDirection = prevIndex < nextIndex;
            return getColumns()
                .sort(function (a, b) { return (a.order || 0) - (b.order || 0); })
                .reduce(function (acc, curr, idx) {
                var currIndex = idx;
                if (prevIndex === currIndex) {
                    acc[curr.id] = nextIndex;
                    return acc;
                }
                if (currIndex === nextIndex) {
                    acc[curr.id] = currIndex + (isForwardDirection ? -1 : 1);
                    return acc;
                }
                if (isForwardDirection && currIndex > prevIndex && currIndex < nextIndex) {
                    acc[curr.id] = currIndex - 1;
                    return acc;
                }
                if (!isForwardDirection && currIndex > nextIndex && currIndex < prevIndex) {
                    acc[curr.id] = currIndex + 1;
                    return acc;
                }
                acc[curr.id] = currIndex;
                return acc;
            }, {});
        }
        var startMove = function (e) {
            var _a, _b, _c, _d;
            if (e.button !== 0) {
                return;
            }
            var nextColumnIndex = 0;
            var rootBoundingClientRect = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            rootLeftOffset = (_b = rootBoundingClientRect === null || rootBoundingClientRect === void 0 ? void 0 : rootBoundingClientRect.left) !== null && _b !== void 0 ? _b : 0;
            scrollLeftOffset = (_d = (((_c = bodyRef.current) === null || _c === void 0 ? void 0 : _c.scrollLeft) || 0)) !== null && _d !== void 0 ? _d : 0;
            var columns = getColumns();
            var columnsSizes = [];
            var offset = 0;
            for (var i = 0; i < columns.length; i++) {
                var width = columns[i].width || 0;
                var half = width / 2;
                columnsSizes.push({
                    leftOffset: offset,
                    rightOffset: offset + width,
                    equator: offset + half
                });
                offset += width;
            }
            function getColumnIndexByCursorPosition(cursorLeftOffset, currentIndex) {
                var limitCursorLeftOffset = Math.min(Math.max(cursorLeftOffset, 0), offset);
                for (var i = 0; i < columnsSizes.length; i++) {
                    var params = columnsSizes[i];
                    if (limitCursorLeftOffset === 0) {
                        return 0;
                    }
                    if (limitCursorLeftOffset === offset) {
                        return columnsSizes.length - 1;
                    }
                    if (limitCursorLeftOffset <= params.leftOffset ||
                        limitCursorLeftOffset > params.rightOffset) {
                        continue;
                    }
                    if (typeof currentIndex === 'undefined') {
                        return i;
                    }
                    if (i === currentIndex) {
                        return i;
                    }
                    if (i < currentIndex) {
                        return limitCursorLeftOffset <= columnsSizes[i].equator ? i : i + 1;
                    }
                    return limitCursorLeftOffset <= columnsSizes[i].equator ? i - 1 : i;
                }
                return currentIndex || 0;
            }
            currentColumnIndex = getColumnIndexByCursorPosition(e.clientX - rootLeftOffset + scrollLeftOffset);
            nextColumnIndex = currentColumnIndex;
            var mouseMoveHandler = function (e) {
                requestAnimationFrame(function () {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    try {
                        (_b = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty) === null || _b === void 0 ? void 0 : _b.call(_a);
                        (_d = (_c = window.getSelection()) === null || _c === void 0 ? void 0 : _c.removeAllRanges) === null || _d === void 0 ? void 0 : _d.call(_c);
                    }
                    catch (_j) { }
                    nextColumnIndex = getColumnIndexByCursorPosition(e.clientX - rootLeftOffset + scrollLeftOffset, currentColumnIndex);
                    var columnIndexWillBeChange = nextColumnIndex !== currentColumnIndex;
                    if (columnIndexWillBeChange) {
                        var isRightDirectionMoving = nextColumnIndex > currentColumnIndex;
                        (_f = (_e = rootRef.current) === null || _e === void 0 ? void 0 : _e.style) === null || _f === void 0 ? void 0 : _f.setProperty('--grid-core-col-moving-indicator-left-position', (isRightDirectionMoving
                            ? columnsSizes[nextColumnIndex].rightOffset - scrollLeftOffset
                            : columnsSizes[nextColumnIndex].leftOffset - scrollLeftOffset) + "px");
                    }
                    (_h = (_g = rootRef.current) === null || _g === void 0 ? void 0 : _g.style) === null || _h === void 0 ? void 0 : _h.setProperty('--grid-core-col-moving-indicator-display', columnIndexWillBeChange ? 'block' : 'none');
                });
            };
            var removeListenersCallbacks = [];
            var stop = function () {
                var _a, _b;
                (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty('--grid-core-col-moving-indicator-display', 'none');
                removeListenersCallbacks.forEach(function (cb) { return cb(); });
            };
            var onMouseUp = function () {
                stop();
                if (nextColumnIndex !== currentColumnIndex) {
                    config.onChange({
                        prevIndex: currentColumnIndex,
                        nextIndex: nextColumnIndex,
                        orders: calculateColumnsOrder({
                            prevIndex: currentColumnIndex,
                            nextIndex: nextColumnIndex
                        })
                    });
                }
            };
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('contextmenu', stop);
            document.addEventListener('mouseup', onMouseUp);
            document.addEventListener('mousedown', stop);
            document.addEventListener('mouseleave', stop);
            document.addEventListener('keydown', stop);
            document.addEventListener('blur', stop);
            removeListenersCallbacks.push(function () {
                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('contextmenu', stop);
                document.removeEventListener('mousedown', stop);
                document.removeEventListener('mouseup', onMouseUp);
                document.removeEventListener('mouseleave', stop);
                document.removeEventListener('keydown', stop);
                document.removeEventListener('blur', stop);
            });
        };
        return {
            processColumns: function (originalColumns) {
                return originalColumns.map(function (column) {
                    return __assign(__assign({}, column), { header: function (props) {
                            return column.header(__assign(__assign({}, props), { className: cn(props.className, styles.draggable), handlers: __assign(__assign({}, props.handlers), { onMouseDown: function (e) {
                                        var _a, _b;
                                        startMove(e);
                                        (_b = (_a = props.handlers) === null || _a === void 0 ? void 0 : _a.onMouseDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                                    } }) }));
                        } });
                });
            },
            containerAddons: [
                {
                    id: 'columnMovingIndicator',
                    order: 99,
                    render: function () { return React.createElement('div', { className: styles.indicator }); }
                }
            ]
        };
    };
}
//# sourceMappingURL=gridColumnMovingPlugin.js.map